/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["hatinggabi","tanghaling-tapat","ng umaga","madaling-araw","ng hapon","ng gabi","ng gabi"],u,u],[["hatinggabi","tanghaling-tapat","umaga","madaling-araw","hapon","gabi","gabi"],u,u],["00:00","12:00",["00:00","06:00"],["06:00","12:00"],["12:00","16:00"],["16:00","18:00"],["18:00","24:00"]]];
